<template>
  <div
    :id="id"
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    data-keyboard="false"
    data-backdrop="static">
    <div
      :class="['modal-dialog', modalClass]"
      role="document">
      <div class="modal-content">
        <div class="modal-header">
          <slot name="header">
            <h5 class="modal-title">
              {{ headerText }}
            </h5>
            <button
              v-if="showCloseButton"
              type="button"
              class="close"
              @click="onClickCloseModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </slot>
        </div>
        <div
          v-if="showBody"
          class="modal-body">
          <slot name="body"/>
        </div>
        <div
          v-if="showFooter"
          :class="[
            'modal-footer',
            footerClasses,
        ]">
          <slot name="footer">
            <button
              v-if="cancelButtonText"
              :disabled="isSubmitted"
              type="button"
              class="btn btn-light"
              @click="onClickCancel"
            >
              {{ cancelButtonText }}
            </button>
            <button
              v-if="sumitButtonText"
              :disabled="isSubmitted"
              type="button"
              class="btn btn-web"
              @click="onClickSubmit"
            >
              <template
                v-if="!isSubmitted"
              >
                {{ sumitButtonText }}
              </template>
              <i
                v-else
                class="fas fa-spinner spin"
              />
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null,
    },
    modalClass: {
      type: String,
      default: null,
    },
    headerText: {
      type: String,
      default: null,
    },
    cancelButtonText: {
      type: String,
      default: null,
    },
    sumitButtonText: {
      type: String,
      default: null,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    isSubmitted: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    showBody () {
      return this.$slots.body
    },
    footerClasses () {
      if (!this.showBody) {
        return 'border-top-none'
      } else {
        return null
      }
    },
  },

  mounted () {
    this.setModal(`#${this.id}`)
  },

  methods: {
    onClickCloseModal () {
      $(`#${this.id}`).modal('hide')
      this.$emit('onClose')
    },
    onClickCancel () {
      this.$emit('onCancel')
    },
    onClickSubmit () {
      this.$emit('onSubmit')
    },
  },
}
</script>

<style scoped>
.border-top-none {
  border-top: none;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseModal.vue